import React from 'react';
import ReactLoader from 'utils/react-loader';
import reactor from 'data/reactor';
import Loader from 'data/loader';
import withRouter from '../ComponentWithRouterProp';

import Getters from 'data/getters';
import OptionsHeader from './student-heading/header-controls/index';
import StudentInfo from './student-heading/student-info';
import StudentModules from './modules';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';
import CreateReactClass from 'create-react-class';
import { onProfileEnter, onProfileEnterSingleStudent } from '../../loaderFunction';
import { SINGLE_STUDENT_PATH } from 'resources/common-values';
import Actions from 'data/actions';

export default withRouter(
    CreateReactClass({
        displayName: 'student-profile',
        mixins: [reactor.ReactMixin, DeepCompareComponentShouldUpdateMixin],

        getInitialState() {
            const pathname = this.props.location.pathname;
            if (pathname == '/students' || pathname == '/family-report' || pathname == '/students/profile') {
                onProfileEnter(this.props);
            } else if (pathname == SINGLE_STUDENT_PATH) {
                onProfileEnterSingleStudent(this.props);
            }
        },

        getDataBindings() {
            if (
                this.props.location.pathname == SINGLE_STUDENT_PATH &&
                !reactor.evaluate(Getters.runtime.singleStudentSearchRendering)
            ) {
                Actions.runtime.resetDisplaySettingsForSingleStudentSearch();
            }

            if(!this.props.location['state']) {
                this.props.location.state = {"studentBid" : reactor.evaluate(Getters.roster.selectedStudentBid)};
            }

            return {
                currentTerm: Getters.partner.currentTerm,
                highlights: Getters.student.highlightsForCurrentStudent,
                isSingleStudentMode: Getters.runtime.singleStudentSearchRendering,
                linkingStudies: Getters.partner.linkingStudies,
                modalReferences: Getters.runtime.modalReferences,
                profileCheckCompleted: Getters.user.profileCheckCompleted,
                selectedClass: Getters.roster.selectedClass,
                selectedModule: Getters.runtime.expandedModule,
                selectedStudentBid: Getters.roster.selectedStudentBid,
                selectedSubject: Getters.runtime.selectedSubject,
                selectedTermNumber: Getters.student.currentlySelectedTermNumber,
                showHighlights: Getters.runtime.showHighlights,
                studentInfo: Getters.student.studentInfoForCurrentStudentBid,
                studentLoaded: Getters.student.currentStudentIsLoaded,
                studentTermData: Getters.student.termDataForCurrentStudent,
                studentTransitionAction: Getters.runtime.studentTransitionAction,
                students: Getters.roster.students,
                subjects: Getters.runtime.subjects,
                terms: Getters.partner.terms,
                termsWithTestEvents: Getters.student.termsWithTestEventsForStudent,
                testEvents: Getters.student.testEventsForCurrentStudent,
                unsavedData: Getters.runtime.unsavedData,
                userAction: Getters.runtime.userAction,
                reportsQueueLink: Getters.user.reportsQueueLink,
            };
        },

        componentDidMount() {
            window.addEventListener('keydown', this.onKeyDown);
        },

        componentDidUpdate() {
            window.onbeforeunload = function() {
                if (this.state.unsavedData) {
                    return 'Your edits have not been saved';
                }
            };
        },

        componentWillUnmount: function() {
            window.removeEventListener('keydown', this.onKeyDown);
        },

        onKeyDown(event) {
            if (event.altKey && event.shiftKey && event.code === 'KeyR') {
                // Alt+Shift+r
                if (this.state.selectedStudentBid) {
                    Loader.reloadStudent(this.state.selectedStudentBid);
                } else {
                    console.log(`currentStudentBid not set`);
                }
            }
        },

        renderChildren() {
            const options = __BATCH__ ? null : (
                <OptionsHeader
                    currentStudentBid={this.state.selectedStudentBid}
                    isSingleStudentMode={this.state.isSingleStudentMode}
                    linkingStudies={this.state.linkingStudies}
                    terms={this.state.terms}
                    termsWithTestEvents={this.state.termsWithTestEvents}
                    selectedSubject={this.state.selectedSubject}
                    selectedModule={this.state.selectedModule}
                    studentInfo={this.state.studentInfo}
                    selectedClass={this.state.selectedClass}
                    students={this.state.students}
                    selectedTermNumber={this.state.selectedTermNumber}
                    unsavedData={this.state.unsavedData}
                    modalReferences={this.state.modalReferences}
                    reportsQueueLink={this.state.reportsQueueLink}
                />
            );
            return (
                <React.Fragment>
                    {options}
                    <StudentInfo
                        currentStudentBid={this.state.selectedStudentBid}
                        studentTransitionAction={this.state.studentTransitionAction}
                        studentInfo={this.state.studentInfo}
                        selectedTermNumber={this.state.selectedTermNumber}
                        testEvents={this.state.testEvents}
                        unsavedData={this.state.unsavedData}
                        selectedSubject={this.state.selectedSubject}
                        currentTerm={this.state.currentTerm}
                        selectedClass={this.state.selectedClass}
                        showHighlights={this.state.showHighlights}
                        highlights={this.state.highlights}
                        highlightsForCurrentStudent={this.state.highlightsForCurrentStudent}
                        expandedModule={this.state.selectedModule}
                    />
                    <StudentModules
                        currentStudentBid={this.state.selectedStudentBid}
                        studentTransitionAction={this.state.studentTransitionAction}
                        studentInfo={this.state.studentInfo}
                        selectedTermNumber={this.state.selectedTermNumber}
                        testEvents={this.state.testEvents}
                        isSingleStudentMode={this.state.isSingleStudentMode}
                        subject={this.state.selectedSubject}
                        terms={this.state.terms}
                        studentTermData={this.state.studentTermData}
                        currentTerm={this.state.currentTerm}
                        modalReferences={this.state.modalReferences}
                        expandedModule={this.state.selectedModule}
                    />
                </React.Fragment>
            );
        },
        render() {
            const readyToLoad =
                this.state.studentLoaded &&
                this.state.profileCheckCompleted &&
                this.state.studentInfo &&
                this.state.selectedTermNumber;
            return (
                <main id="report-content" role="main" className={this.state.userAction}>
                    <ReactLoader loaded={this.state.studentLoaded && this.state.profileCheckCompleted}>
                        {readyToLoad ? this.renderChildren() : null}
                    </ReactLoader>
                </main>
            );
        },
    })
);
